import React from 'react';
import Layout from 'layout';
import BandejaPermisos from './BandejaPermisos';

// import { authenticationService } from 'auth/authenticationService.js'


import {  
    Box,
    Tab, Tabs,
    Grid

} from '@mui/material';
  
function a11yProps(index) {
  return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
  };
}

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    

    this.state = {
      html:{
        tabs:0,
      },
    };
    this.handleTabs = this.handleTabs.bind(this);
  }
  componentDidMount(){
    let local_html = JSON.parse(localStorage.getItem('dashboard'));
    if(local_html){
      this.setState({html:local_html})
    }
    else{

    }
  }
  handleTabs(event, newValue){
    this.setState(prevState => ({
      html: {
          ...prevState.html,
          tabs:newValue,
      },
    }),()=>{
      localStorage.setItem('dashboard',JSON.stringify(this.state.html));
    });
  }
  render() {
    return (
      <Layout title='Inicio'>
        <Box>

          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={this.state.html.tabs} 
                  onChange={this.handleTabs} 
                  aria-label="basic tabs example"
                  indicatorColor="secondary"
                  textColor="inherit"
                  variant="fullWidth"
                  >
              <Tab label="Pendientes a validación" {...a11yProps(0)}/>
              <Tab label="Secciones incompletas" {...a11yProps(1)} />
              <Tab label="Secciones rechazadas" {...a11yProps(2)} />
              <Tab label="Mis permisos" {...a11yProps(3)}/>
              <Tab label="Todos" {...a11yProps(4)}/>
            </Tabs>
          </Box>
          <div role="tabpanel" hidden={this.state.html.tabs !== 0} id="simple-tabpanel-0" aria-labelledby="simple-tab-0">
            { this.state.html.tabs === 0 &&
            <BandejaPermisos tipo='pendiente_validacion'/>
            }
          </div>
          <div role="tabpanel" hidden={this.state.html.tabs !== 1} id="simple-tabpanel-0" aria-labelledby="simple-tab-0">
            { this.state.html.tabs === 1 &&
            <BandejaPermisos tipo='secciones_incompletas'/>
            }
          </div>
          <div role="tabpanel" hidden={this.state.html.tabs !== 2} id="simple-tabpanel-0" aria-labelledby="simple-tab-0">
            { this.state.html.tabs === 2 &&
            <BandejaPermisos tipo='secciones_rechazadas'/>
            }
          </div>
          <div role="tabpanel" hidden={this.state.html.tabs !== 3} id="simple-tabpanel-0" aria-labelledby="simple-tab-0">
            { this.state.html.tabs === 3 &&
            <BandejaPermisos tipo='mios'/>
            }
          </div>
          <div role="tabpanel" hidden={this.state.html.tabs !== 4} id="simple-tabpanel-0" aria-labelledby="simple-tab-0">
            { this.state.html.tabs === 4 &&
            <BandejaPermisos tipo='todos'/>
            }
          </div>
        </Box>
      </Layout>
    );
  }
}

export default Dashboard;
